import React from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import Link from 'next/link';
import IconHeart from 'flaivy-react/components/icons/IconHeart';
import PropTypes from 'prop-types';
import domainModel from 'domain-model';

const { isPrivabShop } = domainModel.shopConfig;
const HeartIconButton = ({ myFavoriteArticles, sessionUser, shopConfig }) => {
  return (
    <Link href="/app/my-favorites">
      {!_.isEmpty(sessionUser) && (
        <Button
          color="none"
          style={{ width: '30px', height: '30px' }}
          id="FavoriteButton"
          className="p-0 me-2 list-inline-item position-relative ms-3"
        >
          <div className="pe-1 pe-md-0">
            <IconHeart stroke={isPrivabShop(shopConfig) ? 'white' : 'black'} />
            <div
              className={`navbar-icon-badge cart-badge ${
                isPrivabShop(shopConfig)
                  ? 'bg-light text-dark'
                  : 'bg-dark text-light'
              }`}
            >
              <strong>{myFavoriteArticles.total}</strong>
            </div>
          </div>
        </Button>
      )}
    </Link>
  );
};

HeartIconButton.propTypes = {
  sessionUser: PropTypes.object.isRequired,
  myFavoriteArticles: PropTypes.object.isRequired,
};

HeartIconButton.defaultProps = {
  sessionUser: null,
};
const mapStateToProps = ({
  myFavoriteArticles,
  authentication,
  shopConfig,
}) => ({
  myFavoriteArticles,
  sessionUser: authentication.sessionUser,
  shopConfig,
});
export default connect(mapStateToProps)(HeartIconButton);
